import React, { useState } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { MagnifyingGlassIcon, BanknotesIcon } from '@heroicons/react/20/solid';

const formatDate = (date) => {
    if (!date) return '';
    const fecha = new Date(date);
    const horas = fecha.getHours();
    const minutos = fecha.getMinutes();
    const ampm = horas >= 12 ? 'PM' : 'AM';
    const horaFormateada = horas % 12 || 12;
    return `${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getDate()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`;
};

const classNames = (...classes) => classes.filter(Boolean).join(' ');

const DetailProfile = ({ penalitie }) => (
    <div className="space-y-4 pt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Nombre Completo</p>
                <p className="font-semibold text-gray-900">{penalitie?.fullnameUser || 'No aplica'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Identificación</p>
                <p className="font-semibold text-gray-900">{penalitie?.identificationUser || 'No aplica'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Placa del Vehículo</p>
                <p className="font-semibold text-gray-900">{penalitie?.numberPlate || 'No requiere'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Marca</p>
                <p className="font-semibold text-gray-900">{penalitie?.brand || 'No requiere'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Modelo</p>
                <p className="font-semibold text-gray-900">{penalitie?.model || 'No requiere'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Correo</p>
                <p className="font-semibold text-gray-900">{penalitie?.email || penalitie?.userEmail || 'No tiene'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Teléfono</p>
                <p className="font-semibold text-gray-900">{penalitie?.phone || 'No tiene'}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg md:col-span-2">
                <p className="text-sm text-gray-600 mb-1">Placa Grúa</p>
                <p className="font-semibold text-gray-900">{penalitie?.towTruckNumberPlate || 'No requiere'}</p>
            </div>
        </div>
    </div>
);

const DetailFine = ({ penalitie }) => (
    <div className="space-y-6 pt-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <p className="text-sm text-blue-600 mb-1">Número de Multa</p>
                <p className="font-semibold text-blue-900">{penalitie?.code}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Fecha</p>
                <p className="font-semibold text-gray-900">{formatDate(penalitie?.dateReg)}</p>
            </div>
            <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                <p className="text-sm text-green-600 mb-1">Monto Total</p>
                <p className="font-semibold text-green-900 text-lg">Bs. {penalitie?.totalBS}</p>
            </div>
            <div className="bg-gray-50 p-3 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Cédula del Oficial</p>
                <p className="font-semibold text-gray-900">{penalitie?.officialIdentification}</p>
            </div>
        </div>

        <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <p className="text-sm text-blue-600 mb-2">Oficial Responsable</p>
            <p className="font-semibold text-blue-900">
                {`${penalitie?.officialFirstName || ''} ${penalitie?.officialFirstLastName || ''}`.trim() || 'No disponible'}
            </p>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm font-medium text-gray-700 mb-3">Descripción</p>
            <p className="text-gray-900 text-justify leading-relaxed">{penalitie?.comment}</p>
        </div>

        <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
            <p className="text-sm font-medium text-amber-700 mb-3">Conceptos de la Multa</p>
            <div className="space-y-3">
                {penalitie?.detailFine?.map((item, index) => (
                    <div key={index} className="bg-white p-3 rounded-lg border border-amber-200">
                        <p className="font-medium text-gray-900 mb-1">• {item.concept}</p>
                        <p className="text-sm text-amber-700">
                            Valor: <span className="font-semibold">{item.valueFine}</span>
                        </p>
                    </div>
                ))}
            </div>
        </div>

        <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm font-medium text-gray-700 mb-3">Evidencia Fotográfica</p>
            {penalitie?.image?.length > 0 ? (
                <div className="flex justify-center">
                    <img
                        src={penalitie?.image[0].url}
                        className="h-64 w-64 object-cover rounded-lg border border-gray-300 shadow-sm"
                        alt='Foto de la infracción'
                    />
                </div>
            ) : (
                <div className="text-center py-8 text-gray-500">
                    <svg className="h-12 w-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <p>No posee evidencia fotográfica</p>
                </div>
            )}
        </div>
    </div>
);

const DetailPayment = ({ penalitie }) => {
    const payments = penalitie?.detailFine?.[0]?.paymentDetail;
    if (payments && payments.length > 0) {
        return (
            <div className="space-y-4 pt-4">
                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                    <div className="flex items-center mb-3">
                        <BanknotesIcon className="h-5 w-5 text-green-600 mr-2" />
                        <p className="text-sm font-medium text-green-700">Historial de Pagos</p>
                    </div>
                    <div className="space-y-3">
                        {payments.map((item, index) => (
                            <div key={index} className="bg-white p-4 rounded-lg border border-green-200 shadow-sm">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Fecha:</span>
                                        <span className="font-semibold text-gray-900">{formatDate(item?.dateReg)}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Monto:</span>
                                        <span className="font-semibold text-green-700 text-lg">Bs. {item?.originalAmount}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Tipo de Pago:</span>
                                        <span className="font-semibold text-gray-900">{item?.paymentTypeDescrip}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Banco:</span>
                                        <span className="font-semibold text-gray-900">{item?.bank}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Banco Receptor:</span>
                                        <span className="font-semibold text-gray-900">{item.bankReceiving ? item.bankReceiving : 'No aplica'}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Referencia:</span>
                                        <span className="font-semibold text-gray-900">{item.reference}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Procesado en:</span>
                                        <span className="font-semibold text-gray-900">{item?.paymentFromDescrip}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Usuario:</span>
                                        <span className="font-semibold text-gray-900">{item?.userName}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Titular del pago:</span>
                                        <span className="font-semibold text-gray-900">{item?.name}</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">Identificación:</span>
                                        <span className="font-semibold text-gray-900">{item?.identification}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="pt-4">
            <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                <BanknotesIcon className="h-12 w-12 mx-auto mb-4 text-gray-300" />
                <p className="text-gray-600 text-lg font-medium mb-2">Sin Pagos Registrados</p>
                <p className="text-gray-500 text-sm">No existen pagos registrados para esta multa.</p>
            </div>
        </div>
    );
};

const PenalitieDetailModal = ({ open, onClose, penalitie }) => {
    const [activeTab, setActiveTab] = useState(0);

    const tabs = [
        { name: 'Detalles de la Persona', id: 0, short: 'Persona' },
        { name: 'Detalles de la Multa', id: 1, short: 'Multa' },
        { name: 'Detalles de pago', id: 2, short: 'Pago' },
    ];

    const statusBadgeClass = {
        'PENDIENTE POR PAGAR': 'bg-red-100 text-red-800',
        'PAGO PARCIAL': 'bg-yellow-100 text-yellow-800',
        'PAGADA': 'bg-green-100 text-green-800',
        'MOROSA': 'bg-orange-100 text-orange-800',
    }[penalitie?.descripStatus] || 'bg-gray-100 text-gray-800';

    return (
        <Dialog open={open} onClose={onClose} className="relative z-50">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in z-40"
            />
            <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-2xl bg-white shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-2xl h-[calc(100vh-2rem)] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 flex flex-col"
                    >
                        <div className="bg-white flex flex-col h-full">
                            <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 flex-shrink-0">
                                <div className="flex items-center">
                                    <MagnifyingGlassIcon className="h-6 w-6 text-gray-600 mr-3" />
                                    <h3 className="text-lg font-semibold text-gray-900">Detalles de la Multa</h3>
                                    <span className={`ml-auto inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${statusBadgeClass}`}>
                                        {penalitie?.descripStatus}
                                    </span>
                                </div>
                            </div>

                            <div className="px-6 py-6 flex-1 overflow-y-auto">
                                <div>
                                    <div className="border-b border-gray-200 bg-gray-50 rounded-t-lg">
                                        <nav aria-label="Tabs" className="flex overflow-x-auto">
                                            {tabs.map((tab) => (
                                                <button
                                                    onClick={() => setActiveTab(tab.id)}
                                                    key={tab.name}
                                                    aria-current={activeTab === tab.id ? 'page' : undefined}
                                                    className={classNames(
                                                        activeTab === tab.id
                                                            ? 'border-indigo-500 text-indigo-600 bg-white shadow-sm'
                                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 hover:bg-gray-100',
                                                        'flex-shrink-0 border-b-2 px-3 py-2 sm:px-4 sm:py-3 text-center text-xs sm:text-sm font-medium rounded-t-lg transition-colors duration-200 whitespace-nowrap'
                                                    )}
                                                >
                                                    <span className="hidden sm:inline">{tab.name}</span>
                                                    <span className="sm:hidden">{tab.short}</span>
                                                </button>
                                            ))}
                                        </nav>
                                    </div>
                                    <div className="bg-white rounded-b-lg">
                                        {activeTab === 0 && <DetailProfile penalitie={penalitie} />}
                                        {activeTab === 1 && <DetailFine penalitie={penalitie} />}
                                        {activeTab === 2 && <DetailPayment penalitie={penalitie} />}
                                    </div>
                                </div>
                            </div>

                            <div className="bg-gray-50 border-t border-gray-200 px-6 py-4 flex justify-end flex-shrink-0">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="inline-flex justify-center items-center px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200 shadow-sm"
                                >
                                    <svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                    </svg>
                                    Volver
                                </button>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default PenalitieDetailModal;
